import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { showHideNavMenuOptionPayload, employeeChangePasswordRequest, employeeChangePasswordRequestStatus } from '../../../redux/user/user.action'
import { API_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import PasswordInputFull from "../../../components/input/password-input-full/passwordInputFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { displayErrorToast, displaySuccessToast, isEmpty } from "../../../utils/Utils";

const EmployeeChangePassword = props => {
    const [isLoading, setLoading] = useState(false)
    let navigate = useNavigate();
    const { user, employeeChangePasswordSuccess, employeeChangePasswordError, employeeChangePasswordReqStatus } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmedPassword] = useState('')

    useEffect(() => {
        if (employeeChangePasswordReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(employeeChangePasswordSuccess.data.message)
            setTimeout(() => {
                dispatch(showHideNavMenuOptionPayload(false))
                navigate(ROUTES.employee.selectLocation, { replace: true })
            }, 800)
        } else if (employeeChangePasswordReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(employeeChangePasswordError.message)
        }
        if (employeeChangePasswordReqStatus?.length) {
            dispatch(employeeChangePasswordRequestStatus(''))
        }
    }, [employeeChangePasswordSuccess, employeeChangePasswordError, employeeChangePasswordReqStatus])

    const handleSkipClick = () => {
        dispatch(showHideNavMenuOptionPayload(false))
        navigate(ROUTES.employee.selectLocation, { replace: true })
    }

    const handleSubmitClick = () => {
        if (isEmpty(password)) {
            displayErrorToast('Password cannot be blank')
        } else if (isEmpty(confirmPassword)) {
            displayErrorToast('Confirm password cannot be blank')
        } else if (password !== confirmPassword) {
            displayErrorToast('Password and confirm password does not match')
        } else {
            setLoading(true)
            const data = {
                employeeId: user.data.userDetails.employeeId,
                employeeLoginCode: user.data.userDetails.employeeLoginCode,
                password: password
            }
            dispatch(employeeChangePasswordRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Change Password'
                    showBackButton={false} />
                <CommonFormBorder>
                    <div className="ecp-skip-label" onClick={() => { handleSkipClick() }}>Skip for now</div>
                    <SubTextLabel label='Your are using default password. Please try changing your password for enhanced security.' />
                    <PasswordInputFull
                        onChange={e => setPassword(e.target.value)}
                        placeholder='Password'
                        value={password} />
                    <CommonInputFloatFull
                        type='text'
                        id='confirmPassword'
                        onChange={e => setConfirmedPassword(e.target.value)}
                        placeholder='Confirm Password'
                        value={confirmPassword} />
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => handleSubmitClick()} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EmployeeChangePassword